import { type APIConfiguration, Service, useList } from "@api/common";
import type { Comment, ListParams } from "./types";

export type { Comment };

export class CommentService extends Service<Comment> {
  constructor() {
    super("/comments");
  }
}

export const commentService = new CommentService();

/** List comments for a task or a customer (the API requires one of the two). */
export function useComments(params?: ListParams<Comment>, config?: APIConfiguration) {
  return useList(commentService, params, {
    ...config,
    skip: config?.skip || (!params?.task && !params?.customer),
  });
}
